import EnvironmentManager from 'Utils/environmentManager';

export const COUPON_PLAYED = 'COUPON_PLAYED';
export const COUPON_CREATED = 'COUPON_CREATED';
export const COUPON_TIMEOUT = 'COUPON_TIMEOUT';
export const COUPON_SBS_RETRY = 'COUPON_SBS_RETRY';
export const COUPON_WAITING = 'COUPON_WAITING';
export const COUPON_CANCELLED = 'COUPON_CANCELLED';
export const COUPON_LOST = 'COUPON_LOST';

export const LIVE = 1040;
export const PRE = 1050;
export const UPCOMING_EVENTS = 999;
export const FAVORITE = 1000;
export const ALL_EVENTS = 9999;

export const FOOTBALL = 1;
export const BASKETBALL = 2;
export const DUELLO = 998;
export const E_FUTBOL = 137;
export const E_BASKETBOL = 153;
export const AMERICAN_FOOTBALL = 16;
export const VOLLEYBALL = 23;
export const HANDBALL = 6;
export const BILLARD = 'x'; //şuanda bilardonun sportType ını bilmiyoruz
export const TENNIS = 5;
export const MOTORSPORTS = 11;
export const SNOOKER = 19;
export const PINGPONG = 20;
export const ICE_HOCKEY = 4;
export const MMA = 117;
export const ZIRVE_ORAN = 160;

/** Sporlar: canlı istatistik data provider'ı yok; İstatistik sekmesinde Sportradar General Statistics widget gösterilir */
export const SPORTS_WITH_GENERAL_STATISTICS_WIDGET = [
  ICE_HOCKEY,
  TENNIS,
  HANDBALL,
  AMERICAN_FOOTBALL,
  PINGPONG,
  BASKETBALL,
  VOLLEYBALL
];

export const LONG_TERM_FOOTBALL = 1001;
export const LONG_TERM_BASKETBALL = 1002;
export const LONG_TERM_TENNIS = 1005;
export const LONG_TERM_HANDBALL = 1006;
export const LONG_TERM_MOTORSPORTS = 1011;
export const LONG_TERM_SNOOKER = 1019;
export const LONG_TERM_VOLLEYBALL = 1023;
export const LONG_TERM_OLIMPICS = 1030;
export const LONG_TERM_PINGPONG = 1020;
export const LONG_TERM_ICE_HOCKEY = 1004;
export const LONG_TERM_MMA = 1117;
export const LONG_TERM_E_FOOTBALL = 1137;
export const LONG_TERM_E_BASKETBALL = 1153;
export const LONG_TERM_AMERICAN_FOOTBALL = 1016;

//e-sport sportTypes
export const E_SPORTS = 9998;
export const CS_GO = 109;
export const LOL = 110;
export const DOTA2 = 111;
export const SC2 = 112;
export const HEARTHSTONE = 113;
export const COD = 118;
export const OVERWATCH = 121;

export const MULTIPLE_SPORT_TYPES = {
  FOOTBALL: [FOOTBALL, 'SOCCER']
};

export const IDDAA_EVENTS = [
  FOOTBALL,
  BASKETBALL,
  VOLLEYBALL,
  HANDBALL,
  BILLARD,
  TENNIS,
  MOTORSPORTS,
  ZIRVE_ORAN,
  SNOOKER
];

export const OUTRIGHTS = [
  LONG_TERM_FOOTBALL,
  LONG_TERM_BASKETBALL,
  LONG_TERM_TENNIS,
  LONG_TERM_HANDBALL,
  LONG_TERM_MOTORSPORTS,
  LONG_TERM_SNOOKER,
  LONG_TERM_VOLLEYBALL,
  LONG_TERM_PINGPONG,
  LONG_TERM_ICE_HOCKEY,
  LONG_TERM_MMA,
  LONG_TERM_OLIMPICS,
  LONG_TERM_E_FOOTBALL,
  LONG_TERM_E_BASKETBALL,
  LONG_TERM_AMERICAN_FOOTBALL
];

export const FINAL_TIME = 'finalTime';
export const TOTAL_GOAL = 'totalGoal';
export const FIRST_HALF = 'firstHalf';
export const BOTH_TEAM_SCORE = 'bothTeamScore';
export const UNDER_OVER = 'underOver';

export const GENERAL_STATS = 'generalStats';
export const HOME_AWAY_STATS = 'homeAwayStats';
export const BETWEEN_STATS = 'betweenStats';

export const BETWEEN_EACH_OTHER = 'between-each-other';
export const FORM_STATUS = 'form-status';

export const AUTHORS = 'yazarlar';
export const FENOMENS = 'fenomenler';

export const PROFILE = 'profilim';
export const NOTIFICATION = 'bildirim-ayarları';

export const MEMBER = 'üye';
export const COUPON = 'kupon';
export const RATIO = 'odd';
export const EARNING = 'earning';

export const MY_NOTIFICATION = 'bana-dair';
export const FOLLOWING_NOTIFICATION = 'takip-ettiklerim';

export const GENERAL = 'general';
export const HOME = 'home';
export const AWAY = 'away';
export const FIXTURE = 'fixture';

export const HOME_SIDE = 'ev-sahibi';
export const AWAY_SIDE = 'deplasman';

export const TEAM_CARD_SIDES = {
  'ev-sahibi': 'HOME',
  deplasman: 'AWAY'
};

export const FIXTURE_DETAIL = 'FIXTURE';
export const PLAYING = 'PLAYING';
export const PLAYED = 'PLAYED';
export const PRE_GAME = 'PRE_GAME';
export const PRE_MATCH = 'PRE_MATCH';

export const CANCELED = 'CANCELED';
export const POSTPONED = 'POSTPONED';
export const SUSPENDED = 'SUSPENDED';
export const AWARDED = 'AWARDED';
export const NONE = 'NONE';

export const STANDARD = 1;
export const HANDICAP_HOME = 2;
export const HANDICAP_AWAY = 3;
export const OTHER = 4;
export const LIMIT = 5;
export const EMPTY = 6;
export const HANDICAP_FULL = 7;
export const BLOCK = 10;
export const GROUP_HANDICAP = 11;
export const MINIMUM_BET_ODD = '1.00';

export const PENALTY = 'PENALTY';

export const HANDICAP_CHECK = [
  HANDICAP_HOME,
  HANDICAP_AWAY,
  GROUP_HANDICAP
];

export const BETTING_PHASE = {
  LIVE: 1,
  PREMATCH: 0
};

export const ODD_NOT_CHANGED = 0;
export const INCREASE = 1;
export const DECREASE = 2;
export const BOTH = 3;

export const SPORTSBOOK = 'SPORTSBOOK';
export const COUPON_WON = 'COUPON_WON';
export const COUPON_SAVED = 'COUPON_SAVED';
export const COUPON_REJECTED = 'COUPON_REJECTED';
export const LIVE_STREAM_STATUSES = {
  NOT_STARTED: 'NOT_STARTED',
  STARTED: 'STARTED'
};

export const LIVE_SCORES_STATUSES = {
  PLAYING: ['PLAYING', 'Playing'],
  FIXTURE: ['FIXTURE', 'Fixture'],
  PLAYED: ['PLAYED', 'Played'],
  POSTPONED: ['POSPOND', 'Pospond', 'POSTPONED', 'Postponed']
};

export const CONTINUED = 'CONTINUED';
export const WON = 'WON';
export const LOST = 'LOST';
export const SAVED = 'SAVED';
export const REJECTED = 'REJECTED';
export const TRIBUN = 'TRIBUN';
export const OUTRIGHT_CONTINUED = 'OUTRIGHT_CONTINUED';
export const OUTRIGHT_WON = 'OUTRIGHT_WON';
export const OUTRIGHT_LOST = 'OUTRIGHT_LOST';
export const OUTRIGHT_SAVED = 'OUTRIGHT_SAVED';

export const COUPON_MAP_BY_TYPE = {
  'devam-eden': CONTINUED,
  kazanan: WON,
  kaybeden: LOST,
  kayitli: SAVED,
  onaylanmayan: REJECTED
};

export const SPACE_COUPON_MIXPANEL_MAP = {
  odd: 'Oran',
  earning: 'Kazanç'
};


// used to match sport types with application routes
export const URL_MAP_BY_TYPE = {
  [FOOTBALL]: 'futbol',
  [BASKETBALL]: 'basketbol',
  [VOLLEYBALL]: 'voleybol',
  [DUELLO]: 'duello',
  [E_SPORTS]: 'e-spor',
  [E_FUTBOL]: 'e-futbol',
  [E_BASKETBOL]: 'e-basketbol',
  [HANDBALL]: 'hentbol',
  [BILLARD]: 'bilardo',
  [MOTORSPORTS]: 'motor-sporlari',
  [TENNIS]: 'tenis',
  [SNOOKER]: 'snooker',
  [PINGPONG]: 'masa-tenisi',
  [ICE_HOCKEY]: 'buz-hokeyi',
  [AMERICAN_FOOTBALL]: 'amerikan-futbol',
  [ZIRVE_ORAN]: 'zirve-oran',
  [MMA]: 'mma',
  [LONG_TERM_FOOTBALL]: 'uzun-vadeli-futbol',
  [LONG_TERM_BASKETBALL]: 'uzun-vadeli-basketbol',
  [LONG_TERM_VOLLEYBALL]: 'uzun-vadeli-voleybol',
  [LONG_TERM_TENNIS]: 'uzun-vadeli-tenis',
  [LONG_TERM_HANDBALL]: 'uzun-vadeli-hentbol',
  [LONG_TERM_SNOOKER]: 'uzun-vadeli-snooker',
  [LONG_TERM_MOTORSPORTS]: 'uzun-vadeli-motor-sporlari',
  [LONG_TERM_OLIMPICS]: 'uzun-vadeli-olimpiyatlar',
  [LONG_TERM_PINGPONG]: 'uzun-vadeli-masa-tenisi',
  [LONG_TERM_ICE_HOCKEY]: 'uzun-vadeli-buz-hokeyi',
  [LONG_TERM_MMA]: 'uzun-vadeli-mma',
  [LONG_TERM_E_FOOTBALL]: 'uzun-vadeli-e-futbol',
  [LONG_TERM_E_BASKETBALL]: 'uzun-vadeli-e-basketbol',
  [LONG_TERM_AMERICAN_FOOTBALL]: 'uzun-vadeli-amerikan-futbol',
  [FAVORITE]: 'favorilerim',
  [UPCOMING_EVENTS]: 'yaklasan-maclar',
  soccer: 'futbol',
  SOCCER: 'futbol',
  BASKETBALL: 'basketbol',
  basketball: 'basketbol',
  tennis: 'tenis',
  TENNIS: 'tenis',
  volleyball: 'voleybol',
  VOLLEYBALL: 'voleybol',
  ICE_HOCKEY: 'buz-hokeyi',
  ice_hockey: 'buz-hokeyi',
  AMERICAN_FOOTBALL: 'amerikan-futbol',
  american_football: 'amerikan-futbol',
  followings: 'takip-ettiklerim',
  'coupon-events': 'kuponumdakiler',
  [CS_GO]: 'counter-strike-global-offence',
  [LOL]: 'league-of-legends',
  [DOTA2]: 'dota-2',
  [SC2]: 'starcraft-2',
  [HEARTHSTONE]: 'hearthstone',
  [COD]: 'call-of-duty',
  [OVERWATCH]: 'overwatch',
  [ALL_EVENTS]: 'tumu',
};

export const SPORT_TYPE_BY_URL = {
  futbol: FOOTBALL,
  basketbol: BASKETBALL,
  duello: DUELLO,
  voleybol: VOLLEYBALL,
  hentbol: HANDBALL,
  bilardo: BILLARD,
  tenis: TENNIS,
  snooker: SNOOKER,
  mma: MMA,
  'zirve-oran': ZIRVE_ORAN,
  'e-futbol': E_FUTBOL,
  'e-basketbol': E_BASKETBOL,
  'amerikan-futbol': AMERICAN_FOOTBALL,
  'motor-sporlari': MOTORSPORTS,
  'masa-tenisi': PINGPONG,
  'buz-hokeyi': ICE_HOCKEY,
  'uzun-vadeli-futbol': LONG_TERM_FOOTBALL,
  'uzun-vadeli-basketbol': LONG_TERM_BASKETBALL,
  'uzun-vadeli-voleybol': LONG_TERM_VOLLEYBALL,
  'uzun-vadeli-tenis': LONG_TERM_TENNIS,
  'uzun-vadeli-hentbol': LONG_TERM_HANDBALL,
  'uzun-vadeli-snooker': LONG_TERM_SNOOKER,
  'uzun-vadeli-motor-sporlari': LONG_TERM_MOTORSPORTS,
  'uzun-vadeli-olimpiyatlar': LONG_TERM_OLIMPICS,
  'uzun-vadeli-masa-tenisi': LONG_TERM_PINGPONG,
  'uzun-vadeli-buz-hokeyi': LONG_TERM_ICE_HOCKEY,
  'uzun-vadeli-mma': LONG_TERM_MMA,
  'uzun-vadeli-e-futbol': LONG_TERM_E_FOOTBALL,
  'uzun-vadeli-e-basketbol': LONG_TERM_E_BASKETBALL,
  'uzun-vadeli-amerikan-futbol': LONG_TERM_AMERICAN_FOOTBALL,
  favorilerim: FAVORITE,
  'yaklasan-maclar': UPCOMING_EVENTS,
  'e-spor': E_SPORTS,
  'counter-strike-global-offence': CS_GO,
  'league-of-legends': LOL,
  'dota-2': DOTA2,
  'starcraft-2': SC2,
  hearthstone: HEARTHSTONE,
  'call-of-duty': COD,
  overwatch: OVERWATCH,
  tumu: ALL_EVENTS,
};

export const LIVE_RESULTS_SPORT_TYPES = {
  all: '',
  soccer: 'futbol',
  basketball: 'basketbol',
  tennis: 'tenis',
  handball: 'hentbol',
  volleyball: 'voleybol',
  snooker: 'snooker',
  'table-tennis': 'masa-tenisi',
  'motor-sports': 'motor-sporlari',
  'ice-hockey': 'buz-hokeyi',
  'coupon-events': 'kuponumdakiler',
  followings: 'takip-ettiklerim',
  mma: 'mma',
  e_soccer: 'e-futbol',
  e_basketball: 'e-basketbol',
  pingpong: 'masa-tenisi',
  'ping-pong': 'masa-tenisi',
  motorsports: 'motor-sporlari',
  'ice hockey': 'buz-hokeyi',
  icehockey: 'buz-hokeyi',
};

export const SPORT_TYPE_UPPER_CASE = {
  futbol: 'Futbol',
  basketbol: 'Basketbol',
  tenis: 'Tenis',
  hendbol: 'Hendbol',
  voleybol: 'Voleybol',
  snooker: 'Snooker',
  'masa-tenisi': 'Masa Tenisi',
  'motor-sporlari': 'Motor Sporları',
  'buz-hokeyi': 'Buz Hokeyi',
  mma: 'Mma',
  duello: 'Düello',

};

// used to match sport types with row types
export const MARKET_ROW_TYPES = {
  [FOOTBALL]: 1,
  [BASKETBALL]: 1,
  [VOLLEYBALL]: 3,
  [HANDBALL]: 1,
  [BILLARD]: 1,
  [TENNIS]: 3,
  [SNOOKER]: 3,
  [FAVORITE]: 1,
  [UPCOMING_EVENTS]: 1,
  [LONG_TERM_FOOTBALL]: 4,
  [LONG_TERM_BASKETBALL]: 4,
  [LONG_TERM_TENNIS]: 4,
  [LONG_TERM_HANDBALL]: 4,
  [LONG_TERM_SNOOKER]: 4,
  [LONG_TERM_MOTORSPORTS]: 4,
  [LONG_TERM_OLIMPICS]: 4,
  [LONG_TERM_E_FOOTBALL]: 4,
  [LONG_TERM_E_BASKETBALL]: 4,
  [LONG_TERM_AMERICAN_FOOTBALL]: 4,
  [PINGPONG]: 3,
  [ICE_HOCKEY]: 3,
  [MMA]: 3,
  [LONG_TERM_PINGPONG]: 4,
  [LONG_TERM_ICE_HOCKEY]: 4,
  [LONG_TERM_MMA]: 4,
  [CS_GO]: 3,
  [LOL]: 3,
  [DOTA2]: 3,
  [SC2]: 3,
  [HEARTHSTONE]: 3,
  [COD]: 3,
  [OVERWATCH]: 3,
  [ALL_EVENTS]: 1
};

export const COMPACT_TYPES = [
  MOTORSPORTS
];

// Durations
export const DURATIONS = {
  SPORTSBOOK_WS_REFRESH: 2500,
  MATCH_CARD_ODDS_WS_REFRESH: +EnvironmentManager.getParameter('socket_odd_add_delay') || 2500,
  BETLINE_DELAY: 25,
  MATCH_CARD_HEADER_REFRESH: +EnvironmentManager.getParameter('score_auto_refresh_interval') || 30,
  ODD_HIGHLIGHT_REMOVE: 1000,
  MATCH_CARD_LIVE_STATISTICS_REFRESH: +EnvironmentManager.getParameter('live_statistics_request_duration') || 15,
  AVAILABLE_TABS_WS_REFRESH: 2500,
  MAINSLIDER_WS_REFRESH: 10000,
};

// Input field lenghts
export const FIELD_LENGTHS = {
  USER_ID_MIN_LENGTH: 8,
  USER_ID_MAX_LENGTH: 8,
  USER_TC_NUMBER_MIN_LENGTH: 11,
  USER_TC_NUMBER_MAX_LENGTH: 11,
  USER_PASSWORD_MIN_LENGTH: 6,
  USER_PASSWORD_MAX_LENGTH: 20,
  USER_BIRTH_DATE_MIN_LENGTH: 8,
  USER_BIRTH_DATE_MAX_LENGTH: 8,
  USER_PHONE_NUMBER_MIN_LENGTH: 10,
  USER_PHONE_NUMBER_MAX_LENGTH: 10,
  BILYONCARD_PASSWORD_LENGTH: 13,
  BILYONCARD_SERIAL_NO_LENGTH: 9,
};

export const BULLETIN_TYPES = {
  LIVE: 1,
  PREMATCH: 2,
  POPULAR: 4
};

// Filter options
export const IS_LIVE_EVENT = 'liveEvent';
export const AUTHOR_COMMENTS = 'authorComments';
export const SORTBYLEAGUE = 'sortByLeague';
export const BYPOPULAR = 'filterAndSortPopular';
export const BYPERSONAL = 'filterAndSortPersonal';
export const HAS_LIVE_STREAM = 'hasLiveStream';
export const PERCENTAGES = 'showPercentages';
export const FILTER_REQUEST_TYPE = 'filterRequestType';
export const MBS1 = 'mbs1';
export const SEARCH = 'searchText';
export const FAVORITES = 'favouriteEvents';
export const RAPID_GAMES_FILTER = 'rapidGamesFilter';
export const HAS_TOP_WIN = 'hasTopWin';
export const XG = 'xg';
export const BYTIME = 'byTime'; //fake filter.
export const SORTBYPOPULAR = 'filterAndSortPopular';
export const SORTBYPERSONAL = 'filterAndSortPersonal';

export const FILTER_OPTIONS = {
  [IS_LIVE_EVENT]: IS_LIVE_EVENT,
  [AUTHOR_COMMENTS]: AUTHOR_COMMENTS,
  [SORTBYLEAGUE]: SORTBYLEAGUE,
  [BYPOPULAR]: BYPOPULAR,
  [BYPERSONAL]: BYPERSONAL,
  [HAS_LIVE_STREAM]: HAS_LIVE_STREAM,
  [PERCENTAGES]: PERCENTAGES,
  [FILTER_REQUEST_TYPE]: FILTER_REQUEST_TYPE
};

export const FILTER_TUMU_WITH_DOT = ':tumu';
export const FILTER_TUMU = 'tumu';

export const FILTER_DATA_TYPES = {
  xg: 'XG',
  league: 'Lig',
  date: 'Tarih',
  mbs: 'MBS',
  events: 'Etkinlik',
  writers: 'Yazarlar',
  liveStreamLeagues: 'canli-yayinlar',
  hasLiveStream: [HAS_LIVE_STREAM],
  liveEvent: [IS_LIVE_EVENT],
  authorComments: [AUTHOR_COMMENTS],
  hasRapidMarket: [RAPID_GAMES_FILTER],
  hasTopWin: [HAS_TOP_WIN],
  search: [SEARCH],
  sortByLeague: [SORTBYLEAGUE],
  BYPOPULAR: [BYPOPULAR],
  BYPERSONAL: [BYPERSONAL],
  favorites: [FAVORITES],
};

export const FILTER_TITLE_KEYS = {
  [FILTER_DATA_TYPES.league]: 'new_bulletin_filter_popular_leagues_title',
  [FILTER_DATA_TYPES.date]: 'new_bulletin_filter_date_title',
  [FILTER_DATA_TYPES.mbs]: 'new_bulletin_filter_mbs_title',
  [FILTER_DATA_TYPES.writers]: 'new_bulletin_filter_authors_title'
};

export const BOOLEAN_FILTERS = [IS_LIVE_EVENT, AUTHOR_COMMENTS, SORTBYLEAGUE, BYPOPULAR, BYPERSONAL, HAS_TOP_WIN, HAS_LIVE_STREAM, PERCENTAGES, FAVORITES, RAPID_GAMES_FILTER];
export const API_FILTERS = [FILTER_REQUEST_TYPE, IS_LIVE_EVENT, AUTHOR_COMMENTS, SORTBYLEAGUE, BYPOPULAR, BYPERSONAL, HAS_LIVE_STREAM, FAVORITES]; // These filters should be requested to api.

// ws changes
export const ODD_ADDED = 'odd-added';
export const ODD_REMOVED = 'odd-removed';
export const ODD_CHANGED = 'odd-changed';
export const EVENT_ADDED = 'event-added';
export const EVENT_REMOVED = 'event-removed';
export const EVENT_CHANGED = 'event-changed';
export const TAB_ADDED = 'tab-added';
export const TAB_REMOVED = 'tab-removed';

export const BETTING_STATUS = {
  SUSPENDED: [-2, -1, '-2', '-1'],
  OPEN: [1, '1'],
  CLOSE: [0, '0'],
  RESULTED_CONFIRMED: [3, '3'],
  RESULTED_NO_CONFIRM: [2, '2']
};

export const WEBSOCKET_ACTIVITY = {
  MATCH_CARD_REFRESH: [EVENT_ADDED],
  MATCH_CARD_UPDATE: [ODD_CHANGED, ODD_REMOVED, ODD_ADDED, EVENT_CHANGED, EVENT_REMOVED, EVENT_ADDED],
  SPORTSBOOK_UPDATE: [ODD_CHANGED, ODD_REMOVED, ODD_ADDED, EVENT_CHANGED, EVENT_REMOVED, EVENT_ADDED],
  BETSLIP_EVENT_UPDATE: [ODD_CHANGED, ODD_REMOVED, ODD_ADDED, EVENT_CHANGED, EVENT_REMOVED, EVENT_ADDED],
  SPORTSBOOK_REFRESH: [EVENT_ADDED],
  SPORTSBOOK_FULL_UPDATE: [EVENT_REMOVED, EVENT_ADDED],
  BETSLIP_EVENT_REMOVE: [EVENT_REMOVED],
  BETSLIP_EVENT_ADD: [EVENT_ADDED],
  POPULAR_BETS_EVENT_REMOVE: [EVENT_REMOVED],
  POPULAR_BETS_ODD_UPDATE: [ODD_CHANGED, ODD_REMOVED, ODD_ADDED, EVENT_CHANGED],
  HOME_POPULAR_BETS_ODD_UPDATE: [ODD_CHANGED, ODD_REMOVED, ODD_ADDED, EVENT_CHANGED],
  POPULAR_BETS_REFRSH: [ODD_CHANGED, ODD_REMOVED, ODD_ADDED, EVENT_CHANGED, EVENT_REMOVED, EVENT_ADDED],
  MAIN_SLIDER: [ODD_CHANGED, ODD_REMOVED, ODD_ADDED, EVENT_CHANGED, EVENT_REMOVED, EVENT_ADDED],

};

// used to select all long term events in one place
export const LONG_TERM_TABS = [
  LONG_TERM_FOOTBALL,
  LONG_TERM_BASKETBALL,
  LONG_TERM_TENNIS,
  LONG_TERM_HANDBALL,
  LONG_TERM_SNOOKER,
  LONG_TERM_MOTORSPORTS,
  LONG_TERM_OLIMPICS,
  LONG_TERM_PINGPONG,
  LONG_TERM_ICE_HOCKEY,
  LONG_TERM_MMA,
  LONG_TERM_E_FOOTBALL,
  LONG_TERM_E_BASKETBALL,
  LONG_TERM_AMERICAN_FOOTBALL,
];

export const GTA_SPORT_TYPE_NAMING = {
  Futbol: 'Futbol',
  SOCCER: 'Futbol',
  [FOOTBALL]: 'Futbol',
  E_FUTBOL: 'E-Futbol',
  [E_FUTBOL]: 'E-Futbol',
  E_BASKETBOL: 'E-Basketbol',
  [E_BASKETBOL]: 'E-Basketbol',
  AMERICAN_FOOTBALL: 'Amerikan Futbolu',
  [AMERICAN_FOOTBALL]: 'Amerikan Futbolu',
  [LONG_TERM_FOOTBALL]: 'UV Futbol',
  [BASKETBALL]: 'Basketbol',
  Basketbol: 'Basketbol',
  BASKETBALL: 'Basketbol',
  [LONG_TERM_BASKETBALL]: 'UV Basketbol',
  [TENNIS]: 'Tenis',
  TENNIS: 'Tenis',
  Tenis: 'Tenis',
  [LONG_TERM_TENNIS]: 'UV Tenis',
  [HANDBALL]: 'Hentbol',
  [LONG_TERM_HANDBALL]: 'UV Hentbol',
  [VOLLEYBALL]: 'Voleybol',
  VOLLEYBALL: 'Voleybol',
  Voleybol: 'Voleybol',
  [LONG_TERM_VOLLEYBALL]: 'UV Voleybol',
  [SNOOKER]: 'Snooker',
  [LONG_TERM_SNOOKER]: 'UV Snooker',
  [MOTORSPORTS]: 'Motor Sporları',
  [LONG_TERM_MOTORSPORTS]: 'UV Motor Sporları',
  [LONG_TERM_OLIMPICS]: 'UV Olimpiyatlar',
  [LONG_TERM_E_FOOTBALL]: 'UV E-Futbol',
  [LONG_TERM_E_BASKETBALL]: 'UV E-Basketbol',
  [LONG_TERM_AMERICAN_FOOTBALL]: 'UV Amerikan Futbol',
  [FAVORITE]: 'Favorilerim',
  [UPCOMING_EVENTS]: 'Yaklaşan Maçlar',
  [PINGPONG]: 'Masa Tenisi',
  [ICE_HOCKEY]: 'Buz Hokeyi',
  [MMA]: 'MMA',
  [LONG_TERM_PINGPONG]: 'UV Masa Tenisi',
  [LONG_TERM_ICE_HOCKEY]: 'UV Buz Hokeyi',
  [LONG_TERM_MMA]: 'UV MMA',
  [CS_GO]: 'Counter Strike Global Offence',
  [LOL]: 'League of Legends',
  [DOTA2]: 'Dota 2',
  [SC2]: 'Starcraft 2',
  [HEARTHSTONE]: 'Hearthstone',
  [COD]: 'Call of Duty',
  [OVERWATCH]: 'Overwatch',
  [ALL_EVENTS]: 'Tümü'
};


export const EVENT_MATCH_STATUS_TYPES = {
  PLAYING: ['Playing', 'PLAYING'],
  PLAYED: ['Played', 'PLAYED', 'Finished', 'FINISHED'],
  FIXTURE: ['Fixture', 'FIXTURE'],
  POSTPONED: ['POSPOND', 'Pospond', 'POSTPONED', 'Postponed', 'postponed', 'CANCELLED', 'Cancelled'],
  SUSPENDED: ['SUSPENDED', 'Suspended', 'suspended']
};

export const EVENT_FIELD_MAPPING = {
  shortLeagueName: 'slgn',
  eventStartDate: 'esd',
  leagueName: 'lgn',
  minSelectionCount: 'mbs',
  hasLiveStream: 'hls',
  hasTopWin: 'htw',
  betradarId: 'brdId',
  bettingStatus: 'bs',
  isLiveEvent: 'il',
  bettingPhase: 'bf',
  startDate: 'strd',
  startTime: 'strt',
  eventType: 'et',
  sportType: 'st',
  eventVersion: 'ev',
  hasWriterComment: 'hwc',
  homeTeamName: 'htn',
  awayTeamName: 'atn',
  channel: 'chnl',
  remainingTime: 'rt',
  eventName: 'en',
  name: 'n',
  longTermEventDisplay: 'lted',
  homeRedCardCount: 'hRCrdCnt',
  awayRedCardCount: 'aRCrdCnt',
  home: 'h',
  away: 'a',
  hasRapidMarket: 'him',
  leagueOrderNo: 'lgo',
  eventStartDateLong: 'esdl',
  competitionId: 'cid',
  writers: 'aut',
  homeTeamJerseyLogo: 'htjl',
  awayTeamJerseyLogo: 'atjl',
  homeTeamId: 'htpi',
  awayTeamId: 'atpi',
  competitionBanner: 'cb',
};

export const LIVE_SCORE_FIELD_MAPPING = {
  awayScore: 'as',
  homeScore: 'hs',
  periodNumber: 'pn',
  periodType: 'pt',
  shortTitle: 't',
  totalScore: 'ts',
};

export const EVENT_STREAM_ICONS = {
  1: 'svgWatchStackCircle',
  2: 'svgTvStackCircle',
  3: 'svgWatchStackCircle',
};

export const EVENT_STREAM_ICONS_HOMEPAGE = {
  1: 'svgWatchStackCircle',
  2: 'svgTvStackCircle',
  3: 'svgWatchStackCircle',
};

export const EVENT_STREAM_NAMES = {
  BILYONER_TV: 'BILYONER_TV',
  OTHER_TV: 'OTHER_TV',
  BOTH: 'BOTH',
};

export const EVENT_STREAM_CODES = {
  0: EVENT_STREAM_NAMES.BILYONER_TV,
  1: EVENT_STREAM_NAMES.BILYONER_TV,
  2: EVENT_STREAM_NAMES.OTHER_TV,
  3: EVENT_STREAM_NAMES.BOTH
};

export const ODD_FIELD_MAPPING = {
  name: 'n',
  value: 'val',
  topWinValue: 'tval',
  hasTopWin: 'htw',
  changeType: 'cht',
  playRatio: 'pr',
  playRatioLabel: 'prl',
  isMostPlayedOdd: 'imo',
  boxType: 'bt',
  outcomeNo: 'ocn',
  marketId: 'mrId',
  marketVersion: 'mrv',
  marketType: 'mrt',
  marketSubType: 'mrst',
  marketStatus: 'mrs',
  marketName: 'mrn',
  handicapSideChange: 'hsc',
  specialOddsType: 'sot',
  specialOddsValue: 'sov',
  specialOddsName: 'som',
  mbs: 'mbs',
  eventId: 'ei',
  totalPlayCount: 'tpc',
  totalPlayAmount: 'tpa',
  hasMarketInfo: 'hmi'
};

export const SOCKET_FIELD_MAPPING = {
  property: 'p',
  eventId: 'ei',
  marketId: 'mrId',
  newValue: 'nv',
  oldValue: 'ov',
  outcomeNo: 'ocn',
  marketGroup: 'mrkGrp',
  matchCardOdd: 'mco',
  tabIdOrder: 'tio',
  tabId: 'ti',
  tabOrder: 'to',
  tabTitle: 'tt',
  marketGroups: 'mgs',
  matchCardOrder: 'mcor',
  otherOddCount: 'odc'
};

// Saved Coupons Filters
export const COUPONS_FILTERS = {
  LAST_7_DAYS: 'LAST_7_DAYS',
  LAST_15_DAYS: 'LAST_15_DAYS',
  LAST_1_MONTH: 'LAST_1_MONTH',
  LAST_3_MONTHS: 'LAST_3_MONTHS',
  LAST_4_MONTHS: 'LAST_4_MONTHS',
  LAST_6_MONTHS: 'LAST_6_MONTHS',
  LAST_1_YEAR: 'LAST_1_YEAR',
  WEEK: 'WEEK',
  ALL: 'ALL'
};

export const COUPON_STATUS_CREATED = 'created';
export const COUPON_STATUS_PLAYED = 'played';
export const COUPON_STATUS_WON = 'won';
export const COUPON_STATUS_LOST = 'lost';

// user contract types
export const MEMBERSHIP_AGREEMENT = 'MEMBERSHIP_AGREEMENT';
export const PRIVACY_POLICY = 'PRIVACY_POLICY';
export const ALL = 'ALL';

// sentry ignore exception codes
export const SENTRY_IGNORE_STATUS_CODES = [
  401,
  403
];

const IDDAA_COUPONS_API_ERROR_CODES = [
  1009, // iddaa-coupons-api / Coupons not found since last 1 week
  1025, // iddaa-coupons-api / Coupons not found since last 1 month
  1026, // iddaa-coupons-api / Coupons not found since last 3 month
  1027, // iddaa-coupons-api / Coupons not found
];

export const SENTRY_IGNORE_DATA_CODES = [
  ...IDDAA_COUPONS_API_ERROR_CODES,
  4058, // users-api - Üye numaranız / E-posta adresiniz veya şifreniz hatalıdır! Lütfen tekrar deneyiniz.
  4005, // sportoto-coupon-api / Kupon bilgileri alınamadı
  4023  // lottery-legacy-service / Hisseli biletiniz bulunmamaktadır.
];

export const LOTTERY_MULTIPLIERS = {
  FLAT_5: 5,
  FLAT_10: 10,
  FLAT_100: 100,
  MIXED_5: 5,
  MIXED_10: 10,
  MIXED_100: 100
};


export const GTM_PAGE_MAPPER = {
  iddaa: 'İddaa',
  'canli-iddaa': 'Canlı İddaa',
  'mac-karti': 'Maç Kartı',
  anasayfa: 'Anasayfa',
  Anasayfa: 'Anasayfa',
  tribun: 'Tribün',
  kuponlarim: 'Kuponlarım',
  'populer-bahisler': 'Popüler bahisler',
  'Canlı Maç İzle': 'Canlı Maç İzle',
  Tümü: 'Tümü',
  'Şans Oyunları': 'Şans Oyunları',
  'asagi-yukari': 'Aşağı - Yukarı',
  'super-tombala': 'Süper Tombala',
  zeplin: 'Zeplin',
  'mayin-tarlasi': 'Mayın Tarlası',
  plinko: 'Plinko',
  'esya-piyangosu': 'Eşya Piyangosu',
  'oyna-kazan': 'Oyna Kazan',
  'canli-skor': 'Canlı Sonuçlar',
  'basketbol-canli-skor': 'Canlı Sonuçlar',
  yazarlar: 'Yazarlar',
  'canli-mac-izle': 'Canlı Maç İzle',
  'canli-futbol-izle': 'Futbol',
  'canli-basketbol-izle': 'Basketbol',
  'canli-tenis-izle': 'Tenis',
  'canli-buz-hokeyi-izle': 'Buz Hokeyi',
  'tjk-tv': 'Tjk'
};

export const GATEWAY_CHANNEL_TYPES = {
  browser: 'WEB',
  tablet: 'TABLET_WEB',
  mobile: 'MOBILE_WEB',
};

export const TIME_DEFAULT_START_DATE = 1566950400000; // 28 Agust

export const BET_PATH = '/iddaa';
export const LIVE_BET_PATH = '/canli-iddaa';
export const MY_COUPONS_PATH = '/kuponlarim';
export const LOGIN_PATH = '/giris-yap';
export const MATCH_CARD_PATH = '/mac-karti';

// Chance Games
export const PARA_LOTO = 'para-loto';
export const SAYISAL_LOTO = 'sayisal-loto';
export const ON_NUMARA = 'on-numara';
export const SANS_TOPU = 'sans-topu';

export const gameTypeConverter = {
  'sans-topu': 'luckyBalls',
  'on-numara': 'tenNumbers',
  'para-loto': 'moneyLotto',
  'sayisal-loto': 'numbersLotto'
};

// Lucky Number Limits
export const LUCKY_NUMBER_LIMITS = {
  'para-loto': 7,
  'sayisal-loto': 7,
  'on-numara': 7,
  'sans-topu': 7
};

export const COMMENT_COUNT_DETAIL = 10;
export const COMMENT_COUNT_TABS = 1;

export const GOAL_TYPES = {
  OWN_GOAL: 'OWN_GOAL',
  GOAL: 'GOAL'
};

export const INFORMAL_BOX_TYPES = [
  2, // handicap
  3, // handicap deplasman
  5  // limit, frame, oyun
];

export const MATCH_CARD_PRIMARY_TABS = {
  ODDS: { visibleBadge: false, badgeText: null },
  COUPON_ORDER: { visibleBadge: 'coupon_order_match_card_badge', badgeText: 'coupon_order_match_card_badge_text' },
  MATCH_INFO: { visibleBadge: false, badgeText: null },
  MATCHES: { visibleBadge: false, badgeText: null },
  STATISTICS: {  visibleBadge: false, badgeText: null },
  GLOBAL_RANKING: { visibleBadge: 'global_ranking_match_card_badge' },
  HIGHLIGHTS: { visibleBadge: false },
  HOT_BETS: { visibleBadge: 'match_card_hotbets_tab_badge_visible_sportid', badgeText: 'match_card_hotbets_tab_badge_text' },
  TRIBUNE: { visibleBadge: 'match_card_tribune_new_badge_visible' }
};

export const MATCH_CARD_TAB_MAP = {
  oranlar: 'ODDS',
  detay: 'MATCH_INFO',
  'mac-detay': 'MATCH_INFO',
  kadro: 'MATCH_INFO',
  'ilk-11ler': 'MATCH_INFO',
  'sakat-cezali': 'MATCH_INFO',
  'akilli-analiz': 'MATCH_INFO',
  eslesmeler: 'MATCHES',
  karsilastirma: 'STATISTICS',
  'canli-istatistikler': 'STATISTICS',
  istatistikler: 'STATISTICS',
  istatistik: 'STATISTICS',
  tahminler: 'PREDICTIONS',
  kuponlar: 'TRIBUNE',
  yazarlar: 'TRIBUNE',
  'kupon-emri': 'COUPON_ORDER',
  'onemli-anlar': 'HIGHLIGHTS',
  'dunya-siralamasi': 'GLOBAL_RANKING',
  'sicak-bahisler': 'HOT_BETS',
};

export const MATCH_CARD_SECONDARY_TABS_NAME_MAP = {
  ['İstatistikler']: 'Karşılaştırma',
};

// tabType -> URL slug mapping for sub tabs
export const MATCH_CARD_TAB_TYPE_TO_URL_MAP = {
  ODDS: 'oranlar',
  STANDINGS: 'puan-durumu',
  WRITER: 'yazarlar',
  SMARTFACTS: 'akilli-analiz',
  H2H: 'karsilastirma',
  MISSINGS: 'sakat-cezali',
  STATISTICS: 'istatistikler',
  MATCH_INFO: 'mac-detay',
  LIVE_STATISTICS: 'canli-istatistikler',
  DETAIL: 'detay',
  LINE_UP: 'kadro',
  MATCHES: 'eslesmeler',
  TRIBUNE: 'kuponlar',
  TRIBUNE_COUPONS: 'kuponlar',
  COUPONS: 'kuponlar',
  PREDICTIONS: 'tahminler',
  STREAKS: 'seriler',
  REFEREE_STATS: 'hakem-istatistikleri',
  BAS_FORM: 'form',
  BAS_MARKET_STATS: 'bahis-istatistikleri',
  BAS_UNDER_OVER_ANALYSIS: 'alt-ust-istatistikleri',
  POSITION_MATRIX: 'puan-durumu-matrisi',
  HIGHLIGHTS: 'onemli-anlar',
  COUPON_ORDER: 'kupon-emri',
  GLOBAL_RANKING: 'dunya-siralamasi',
  HOT_BETS: 'sicak-bahisler',
  PLAYER_ANALYSIS: 'oyuncu-analizi',
  BOX_SCORE: 'oyuncu-istatistikleri',
  BAHISTA: 'bahista-yapay-zeka-iddaa-tahminleri',
};

export const BASKETBALL_Q1 = 'BASKETBALL_Q1';
export const BASKETBALL_Q2 = 'BASKETBALL_Q2';
export const BASKETBALL_Q3 = 'BASKETBALL_Q3';
export const BASKETBALL_Q4 = 'BASKETBALL_Q4';
export const BASKETBALL_FIRST_HALF = 'BASKETBALL_FIRST_HALF';
export const BASKETBALL_TOTAL_SCORE = 'BASKETBALL_TOTAL_SCORE';
export const BASKETBALL_EXT1 = 'BASKETBALL_EXT1';
export const BASKETBALL_EXT2 = 'BASKETBALL_EXT2';

export const HALF_TIME_BREAK = 'HALF_TIME_BREAK';
export const HALF_TIME = 'HALF_TIME';
export const FIRST_HALF_PERIOD = 'FIRST_HALF';

export const BASKETBALL_SCORE_ORDER = {
  [BASKETBALL_Q1]: 1,
  [BASKETBALL_Q2]: 2,
  [BASKETBALL_FIRST_HALF]: 3,
  [BASKETBALL_Q3]: 4,
  [BASKETBALL_Q4]: 5,
  [BASKETBALL_TOTAL_SCORE]: 6,
};

export const AMERICAN_FOOTBALL_Q1 = 'AMERICAN_FOOTBALL_Q1';
export const AMERICAN_FOOTBALL_Q2 = 'AMERICAN_FOOTBALL_Q2';
export const AMERICAN_FOOTBALL_Q3 = 'AMERICAN_FOOTBALL_Q3';
export const AMERICAN_FOOTBALL_Q4 = 'AMERICAN_FOOTBALL_Q4';
export const AMERICAN_FOOTBALL_FIRST_HALF = 'AMERICAN_FOOTBALL_FIRST_HALF';
export const AMERICAN_FOOTBALL_TOTAL_SCORE = 'AMERICAN_FOOTBALL_TOTAL_SCORE';
export const AMERICAN_FOOTBALL_EXT1 = 'AMERICAN_FOOTBALL_EXT1';
export const AMERICAN_FOOTBALL_EXT2 = 'AMERICAN_FOOTBALL_EXT2';

export const AMERICAN_FOOTBALL_SCORE_ORDER = {
  [AMERICAN_FOOTBALL_Q1]: 1,
  [AMERICAN_FOOTBALL_Q2]: 2,
  [AMERICAN_FOOTBALL_FIRST_HALF]: 3,
  [AMERICAN_FOOTBALL_Q3]: 4,
  [AMERICAN_FOOTBALL_Q4]: 5,
  [AMERICAN_FOOTBALL_TOTAL_SCORE]: 6,
};

// Handball Score Constants
export const HANDBALL_FIRST_HALF = 'HANDBALL_FIRST_HALF';
export const HANDBALL_TOTAL_SCORE = 'HANDBALL_TOTAL_SCORE';

export const TABLE_TENNIS_SET = 'TABLE_TENNIS_SET';
export const TABLE_TENNIS_SET1 = 'TABLE_TENNIS_SET1';
export const TABLE_TENNIS_SET2 = 'TABLE_TENNIS_SET2';
export const TABLE_TENNIS_SET3 = 'TABLE_TENNIS_SET3';
export const TABLE_TENNIS_SET4 = 'TABLE_TENNIS_SET4';
export const TABLE_TENNIS_SET5 = 'TABLE_TENNIS_SET5';
export const TABLE_TENNIS_TOTAL = 'TABLE_TENNIS_TOTAL';

export const TOTAL = 'TOTAL';
export const CURRENT = 'CURRENT';
export const SCORE_TYPE_PERIOD = 'PERIOD';


export const MULTIPLE_COUPON_PLAY_TYPE_ORDER = {
  [COUPON_WAITING]: 1,
  [COUPON_PLAYED]: 2,
  [COUPON_REJECTED]: 3,
};

export const BOXTYPE_EQUALTY = {
  STANDART: 1,
  HANDICAPHOME: 2,
  HANDICAPAWAY: 3,
  OTHER: 4,
  LIMIT: 5,
  EMPTY: 6,
  HANDICAPBOTH: 7,
  SPECIAL: 8, //uzun vadeli
  SPECIAL_SINGLE: 9, //tekli gosterilen oddlar
  SPECIAL_TWIN: 10, //ikili gosterilen oddlar
  FAKE: 11,
  INVISIBLE_TYPE: 12
};

export const HEADER_TAB_SPORT_TYPE_MAP = {
  tümü: 'ALL',
  futbol: 'SOCCER',
  basketbol: 'BASKETBALL',
  tenis: 'TENNIS',
  voleybol: 'VOLLEYBALL'
};


export const POPULAR_BETS_TAB_PARAMS = {
  RECOMMENDED: 'sana-ozel-maclar',
  LIVE: 'canli',
  PRE: 'yakinda-baslayacak',
  ALL: 'tümü',
  TRENDING: 'trend-olan-maclar',
  POPULAR: 'populer-bahisler',
  FOOTBALL: 'futbol',
  BASKETBALL: 'basketbol',
  E_SPORTS: 'e-spor',
  TENNIS: 'tenis',
};
export const NATIVE_SCOREBOARD_PERIOD_TYPE = [
  '5. Set',
  '4. Set',
  '3. Set',
  '2. Set',
  '1. Set',
];

export const SG_ERROR_TYPE_1 = [
  'iddaa-coupons-api1001',
  'iddaa-coupons-api1032',
  'iddaa-coupons-api1033',
  'iddaa-coupons-api1023'
];


export const MATCH_CARD_POPULAR_BETS_TAB_ID = 99;
export const MATCH_CARD_PERSONAL_BETS_TAB_ID = 98;
